import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const mdmActionTypes = ActionTypesFactory.readActionTypes(
  "MDM"
);

export default mdmActionTypes;
